import React from "react";
import "./SectionDaftar.css";
import imgDaftarSekarang from "../../assets/sec_daftar_sekarang/Daftar_Sekarang_Juga.webp";

const SectionDaftar = () => {
  return (
    <React.Fragment>
      <div className="container-section-daftar">
        <div className="text-section-daftar">
          <h1 className="title-section-daftar">
            Daftar Sekarang Juga!! <br /> Waktu dan Kuota Terbatas
          </h1>
          <p className="desk-section-daftar">
            Jangan buang-buang waktu, persiapkan dirimu dari sekarang dan
            pastikan kamu menjadi salah satu yang terbaik diantara ribuan
            pesaingmu
          </p>
          <a
            href="https://api.whatsapp.com/send?phone=6281216365729&text=Halo%20Kak%20Nia%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20Bimbel%20TNI-POLRI%20Bagaimana%20penjelasan%20detail%20Programnya?"
            className="btn-section-daftar"
          >
            Daftar Disini
          </a>
        </div>
        <img
          src={imgDaftarSekarang}
          alt="Bimbel Akmil"
          className="img-section-daftar-sekarang"
        />
      </div>
    </React.Fragment>
  );
};

export default SectionDaftar;
